<template>
  <div class="ny">
    <div class="main">
      <div class="ny_bt1 mh md20">
        <span class="bt left">帮助中心</span>
      </div>
      <ul class="pro_list md30">
             <li v-for="(Item,index) in gslist.Items" :key="index">
          <a href="javascript:void(0)" @click="togsDetail(Item)">
            <h5 class="bt">{{Item.Title}}</h5>
            <span class="sj">{{Item.AddTime}}</span>
          </a>
        </li>
     </ul>
     <div class="mh fy" v-show="total>0">
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pagenum"
                :page-sizes="[5, 10, 15, 20]"
                :page-size="pageSize"
                layout="prev, pager, next"
                 background
                :total="total">
              </el-pagination>
     </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import http from "../http/http";
import api from "../http/api";
export default {
  data() {
    return {
   gslist:[],
         pagenum:1,
         pageSize:10,
         total:0
    };
  },
    mounted() {
    //加载列表
    this.listData();
  },
  methods: {
  //列表
      listData: async function () {
      let params = {
        Page:this.pagenum,
        PageSize:this.pageSize
      }
      const res = await http.get(api.apigethelplistbypage, params)
      this.gslist=res.data.obj;
      // console.log(res);
      // console.log(this.gslist);
      // this.pagenum=res.data.obj.TotalPages;
      this.pageSize=res.data.obj.ItemsPerPage;
      this.total=res.data.obj.TotalItems;
    },
    // 跳转到搜索详情页
      togsDetail(item) {
        this.$router.push({
          name: "helpDetail",
          query: {
            HelpId:item.HelpId,
          }
        });
      },
      // 监听每页条数变动
      handleSizeChange(val){
        this.pageSize = val
        this.listData()
      }, 
      // 监听页码变动
      handleCurrentChange(newPage) {
        this.pagenum = newPage
        this.listData()
      },
   },
  created: function () {
    // this.$emit('header', false);
  },

};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/page/help_list.vue